var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Bed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74419 8.46442C8.2818 8.46442 7.90698 8.83923 7.90698 9.30163V14.604H24.093V9.30163C24.093 8.83923 23.7182 8.46442 23.2558 8.46442H8.74419ZM6.23256 9.30163C6.23256 7.91446 7.35706 6.79 8.74419 6.79H23.2558C24.643 6.79 25.7674 7.91447 25.7674 9.30163V15.4412C25.7674 15.9035 25.3926 16.2784 24.9302 16.2784H7.06977C6.60739 16.2784 6.23256 15.9035 6.23256 15.4412V9.30163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95349 21.3016C6.41587 21.3016 6.7907 21.6765 6.7907 22.1388V24.3714C6.7907 24.8338 6.41587 25.2086 5.95349 25.2086C5.49111 25.2086 5.11628 24.8338 5.11628 24.3714V22.1388C5.11628 21.6765 5.49111 21.3016 5.95349 21.3016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0465 21.3016C26.5089 21.3016 26.8837 21.6765 26.8837 22.1388V24.3714C26.8837 24.8338 26.5089 25.2086 26.0465 25.2086C25.5841 25.2086 25.2093 24.8338 25.2093 24.3714V22.1388C25.2093 21.6765 25.5841 21.3016 26.0465 21.3016Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6977 14.3249C10.6977 12.9377 11.8221 11.8133 13.2093 11.8133H18.7907C20.1779 11.8133 21.3023 12.9377 21.3023 14.3249V15.4412C21.3023 15.9035 20.9275 16.2784 20.4651 16.2784H11.5349C11.0725 16.2784 10.6977 15.9035 10.6977 15.4412V14.3249ZM13.2093 13.4877C12.7469 13.4877 12.3721 13.8625 12.3721 14.3249V14.604H19.6279V14.3249C19.6279 13.8625 19.2531 13.4877 18.7907 13.4877H13.2093Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51163 16.2784C6.04924 16.2784 5.67442 16.6532 5.67442 17.1156V21.3016H26.3256V17.1156C26.3256 16.6532 25.9508 16.2784 25.4884 16.2784H6.51163ZM4 17.1156C4 15.7284 5.12451 14.604 6.51163 14.604H25.4884C26.8755 14.604 28 15.7284 28 17.1156V22.1388C28 22.6012 27.6252 22.976 27.1628 22.976H4.83721C4.37483 22.976 4 22.6012 4 22.1388V17.1156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Bed);
export default __webpack_public_path__ + "static/media/1-Bed.9f6a2c6be0819edeee63d192f040486f.svg";
export { ForwardRef as ReactComponent };